import React, { Component } from 'react';

class Footer extends Component {
    render() {
        
        const date = new Date();
        const getCurrentYear = date.getFullYear();

        return (
            <div className="footer fixed">
                <div className="pull-right" />
                <div>
                    <strong>Copyright</strong> &copy; 2017-{getCurrentYear}
                </div>
            </div>
        );
    }
}

export default Footer;
